import React from "react";
import ShareIcon from "@material-ui/icons/Share";

interface Props {
  openShareDialog: () => void;
  buttonStyles: string;
}

const ShareButton = ({ buttonStyles, openShareDialog }: Props) => {
  return (
    <button id="share-button" className={buttonStyles} type="button" onClick={openShareDialog}>
      <ShareIcon />
    </button>
  );
};

export default ShareButton;
